import { render, staticRenderFns } from "./HtmlBlock.vue?vue&type=template&id=6f638a6a&scoped=true"
import script from "./HtmlBlock.vue?vue&type=script&lang=js"
export * from "./HtmlBlock.vue?vue&type=script&lang=js"
import style0 from "./HtmlBlock.vue?vue&type=style&index=0&id=6f638a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f638a6a",
  null
  
)

export default component.exports